/** @jsxRuntime classic */
/** @jsx jsx */
import {
  Alert,
  AlertDescription,
  Box,
  Button,
  Center,
  Flex,
  Heading,
} from '@chakra-ui/react';
import { css, jsx } from '@emotion/react';
import axios from 'axios';
import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  DoNotShowWrite,
  selectLogin,
  selectUser,
} from '../redux/loginSlice.js';
import Footer from './layout/Footer';
import Header from './layout/HeaderB';
import './Styles.css';

export default function Write({ user }) {
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [score, setScore] = useState('');
  const [file, setFile] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const View = useSelector(selectLogin);
  const User = useSelector(selectUser);
  const dispatch = useDispatch();

  const handleSubmit = async e => {
    e.preventDefault();
    let restaurant_id = id;
    let username = User;
    const formData = new FormData();
    formData.append('image', file);
    formData.append('username', username);
    formData.append('title', title);
    formData.append('desc', desc);
    formData.append('score', score);
    formData.append('restaurant_id', restaurant_id);
    try {
      await axios.post(
        'https://mern-stack-restaurants-app.herokuapp.com/reviews/add',
        formData
      );
      setTitle('');
      setDesc('');
      setScore('');
      setFile(null);
      document.getElementById('fileInput').value = '';
      const notify = () => toast.success('Review has been added!');
      notify();
    } catch (err) {
      const notify = () => toast.error('An error occurred!');
      notify();
    }
  };
  return (
    <React.Fragment>
      <Box
        css={{
          minHeight: 'calc(100vh - 80px)',
          backgroundSize: 'cover',
          marginBottom: '-5px',
        }}
      >
        <Toaster />
        <Header />
        {View === 'Login' && (
          <Flex direction="row" wrap="wrap" justify="center">
            <Flex direction="column">
              <Heading
                css={css`
                  @media (max-width: 350px) {
                    font-size: 16px;
                  }
                `}
                as="u"
                mb={5}
              >
                Write a Review
              </Heading>
              <form
                onSubmit={handleSubmit}
                css={css`
                  @media (max-width: 350px) {
                    font-size: 13px;
                  }
                `}
              >
                <input
                  css={{
                    padding: '10px 5px',
                    display: 'block',
                    marginTop: '10px',
                  }}
                  type="text"
                  placeholder="Title"
                  value={title}
                  size="30"
                  autoFocus={true}
                  onChange={e => setTitle(e.target.value)}
                />
                <textarea
                  css={{
                    display: 'block',
                    marginTop: '20px',
                  }}
                  placeholder="Write a review"
                  value={desc}
                  type="text"
                  rows="4"
                  cols="30"
                  onChange={e => setDesc(e.target.value)}
                ></textarea>
                <input
                  css={{
                    padding: '10px 5px',
                    display: 'block',
                    marginTop: '20px',
                    width: 'auto',
                  }}
                  type="number"
                  placeholder="Give a score 1-5"
                  value={score}
                  autoFocus={true}
                  onChange={e => setScore(e.target.value)}
                />
                <label
                  for="fileInput"
                  css={{
                    display: 'block',
                    marginTop: '20px',
                    width: '200px',
                  }}
                >
                  Add an Image (jpg/jpeg/png/webp)
                </label>
                <input
                  css={{
                    display: 'block',
                    marginTop: '20px',
                  }}
                  type="file"
                  name="image"
                  id="fileInput"
                  onChange={e => setFile(e.target.files[0])}
                />
                <Box my={5}>
                  <Flex direction="row" wrap="wrap" justify="center">
                    <Button
                      type="submit"
                      disabled={
                        title === '' || desc === '' || score < 1 || score > 5
                      }
                      bg="#3f51b5"
                    >
                      Send
                    </Button>
                    <Button
                      css={{
                        marginLeft: '10px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                      onClick={e => {
                        window.location.reload();
                        dispatch(DoNotShowWrite());
                      }}
                      bg="#3f51b5"
                    >
                      Refresh page and logout
                    </Button>
                  </Flex>
                </Box>
              </form>
            </Flex>
          </Flex>
        )}
        {View === 'Logout' && (
          <>
            <Center>
              <Alert bg="#f9bf3b" color="#000" w={500}>
                <AlertDescription px={1} py={1}>
                  To be able to write a review you have to register and login
                </AlertDescription>
              </Alert>
            </Center>
            <Center>
              <Button
                css={css`
                  @media (max-width: 350px) {
                    font-size: 13px;
                  }
                `}
                colorScheme="blue"
                my={5}
              >
                <Link to={`/auth`} style={{ color: '#fff' }}>
                  Register and Login
                </Link>
              </Button>
            </Center>
          </>
        )}
      </Box>
      <Footer />
      <Button
        onClick={() => {
          navigate(-1);
        }}
        css={css`
          position: fixed;
          zindex: 100;
          top: 25%;
          left: 0;
          @media (max-width: 350px) {
            font-size: 13px;
          }
        `}
        colorScheme="blue"
      >
        Back
      </Button>
    </React.Fragment>
  );
}
